var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main-section', {
    staticClass: "main-section--sm pt-0"
  }, [_c('square-title', [_vm._v("협력 파트너사")]), _c('v-row', {
    attrs: {
      "justify": "center"
    }
  }, _vm._l(_vm.partners, function (partner, index) {
    return _c('v-col', {
      key: index,
      attrs: {
        "cols": "6",
        "md": "4",
        "lg": "3"
      }
    }, [_c('v-card', {
      staticClass: "partner-card rounded-xl",
      attrs: {
        "outlined": ""
      }
    }, [_c('div', [_c('v-img', {
      staticClass: "mx-auto mb-16px",
      attrs: {
        "max-width": "154",
        "src": partner.logo,
        "alt": ""
      }
    }), _c('div', {
      staticClass: "font-size-12 font-size-md-20 grey--text text--darken-4 text-pre-wrap"
    }, [_vm._v(_vm._s(partner.name))])], 1)])], 1);
  }), 1), _c('p', {
    staticClass: "tit tit--xs text-center pt-6 pt-md-10"
  }, [_vm._v("협력 연구 등을 위해 지역의 대학, 연구소, 진흥원, 센터 등과 활발한 교류로 "), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v("기술력 축적")]), _vm._v(" 및 "), _c('span', {
    staticClass: "primary--text"
  }, [_vm._v("신제품 출시")])])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }